import React from "react";
import { useTaxonomy } from "library/utils/useTaxonomy";
import { CenteredCell } from "../../../components/styled";

interface TransportTypeCellProps {
  transportType?: string | null;
}

export const TransportTypeCell: React.FC<TransportTypeCellProps> = ({
  transportType,
}) => {
  const taxonomy = useTaxonomy();

  if (!transportType) {
    return <CenteredCell>-</CenteredCell>;
  }

  // Look up the taxonomy item by code
  const transportTypeTaxonomy =
    taxonomy?.VehicleTransportType?.byId?.[transportType];

  if (!transportTypeTaxonomy) {
    return <CenteredCell>{transportType}</CenteredCell>;
  }

  // Display the code directly (no translations exist for these)
  return <CenteredCell>{transportTypeTaxonomy.code}</CenteredCell>;
};
